import React from "react";
import { Box, Typography } from "@mui/material";
import {
  ResponsiveChartContainer,
  BarPlot,
  LinePlot,
  MarkPlot,
  ChartsXAxis,
  ChartsYAxis,
  ChartsGrid,
  ChartsTooltip,
  ChartsAxisHighlight,
  ChartsLegend,
} from "@mui/x-charts";
import { DP } from "./constants";

const trNumber = (n) => Number(n || 0).toLocaleString("tr-TR");

// Gün / Ürün / Personel görünümleri için ortak grafik:
// bar = satış tutarı (sol eksen, ₺), line = adet (sağ eksen).
export default function ReportChart({ title, labels, amounts, counts }) {
  if (!labels.length) return null;

  return (
    <Box sx={{ width: "100%" }}>
      {title && (
        <Typography sx={{ fontWeight: 700, color: DP.textMain, mb: 1 }}>
          {title}
        </Typography>
      )}
      <ResponsiveChartContainer
        height={340}
        series={[
          {
            type: "bar",
            data: amounts,
            label: "Satış Tutarı (₺)",
            yAxisId: "amount",
            color: DP.primary,
            valueFormatter: (v) => `${trNumber(v)} ₺`,
          },
          {
            type: "line",
            data: counts,
            label: "Adet",
            yAxisId: "count",
            color: DP.success,
            valueFormatter: (v) => `${trNumber(v)} adet`,
          },
        ]}
        xAxis={[{ id: "x", scaleType: "band", data: labels }]}
        yAxis={[
          { id: "amount", valueFormatter: (v) => trNumber(v) },
          { id: "count", position: "right" },
        ]}
        margin={{ left: 80, right: 60, top: 30, bottom: 90 }}
      >
        <ChartsGrid horizontal />
        <BarPlot />
        <LinePlot />
        <MarkPlot />
        <ChartsAxisHighlight x="band" />
        <ChartsXAxis
          axisId="x"
          tickLabelStyle={{ angle: -30, textAnchor: "end", fontSize: 11 }}
        />
        <ChartsYAxis axisId="amount" label="Tutar (₺)" />
        <ChartsYAxis axisId="count" label="Adet" />
        <ChartsTooltip />
        <ChartsLegend />
      </ResponsiveChartContainer>
    </Box>
  );
}
